
export interface CoreGoogleGroupConfiguration {
    id: string
    groupTypes: GoogleGroupGroupTypes
    ownerMode: GoogleGroupMemberMode
    memberMode: GoogleGroupMemberMode
    inactivePeriod: number
    deletePeriod: number | null
    whoCanViewMembership: GoogleGroupWhoCanViewMemberShip
    whoCanPostMessage: GoogleGroupWhoCanPostMessage
    whoCanModerateMembers: GoogleGroupWhoCanModerateMembers
    whoCanJoin: GoogleGroupWhoCanJoin
    whoCanViewGroup: GoogleGroupWhoCanViewGroup
    includeInGlobalAddressList: boolean
    domainName?: string
    syncClassroomTeacherMembers: boolean
    activityInformationMarkingFilters: string[]
}

export enum GoogleGroupGroupTypes {
    None = 0,
    Classes = 1,
    SubjectOrCourse = 2,
    MentorGroup = 4,
    TeacherOwnerStudentMember = 8,
    TeacherMember = 16,
    StudentMember = 32,
    StaffMember = 64,
    StaffAndTeacherOwnerStudentMember = 128,
    ClassStudentMember = 256
};

export enum GoogleGroupMemberMode {
    STRICT = 0,
    PERMISSIVE = 1
};

export enum GoogleGroupWhoCanViewMemberShip {
    AllInDomain = 1,
    AllMembers = 2,
    AllManagers = 3,
};

export enum GoogleGroupWhoCanPostMessage {
    AllManagers = 2,
    AllMembers = 3,
    AllOwners = 4,
    AllInDomain = 5,
    Anyone = 6,
};

export enum GoogleGroupWhoCanModerateMembers {
    AllMembers = 1,
    OwnersAndManagers = 2,
    OwnersOnly = 3,
    None = 4,
};

export enum GoogleGroupWhoCanJoin {
    Anyone = 1,
    AllInDomain = 2,
    Invited = 3,
    RequestToJoin = 4,
};

export enum GoogleGroupWhoCanViewGroup {
    Anyone = 1,
    AllInDomain = 2,
    AllMembers = 3,
    AllManagers = 4,
    AllOwners = 5
};
